export enum ChatMessageErrorType {
    PERMISSION_DENIED = 'PERMISSION_DENIED',
    RATE_LIMIT = 'RATE_LIMIT',
    UNAVAILABLE = 'UNAVAILABLE',
    NETWORK = 'NETWORK',
    CONTEXT_LIMIT = 'CONTEXT_LIMIT',
}
